import { render, staticRenderFns } from "./ExistingDocumentRegisterView.vue?vue&type=template&id=39e03a70&"
import script from "./ExistingDocumentRegisterView.vue?vue&type=script&lang=ts&"
export * from "./ExistingDocumentRegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports